export default {
  structure: {
    titreHeader: {
      title: "City of Carouge's logo",
      alt: "City of Carouge"
    }
  },
  message: {
    error: {
      404: {
        title: "404 - Moved or deleted page",
        msg:
          "The page you requested could not be found, it has been moved, deleted or never existed."
      },
      unauthorized: "You are not allowed to visit this page."
    },
    title: {
      line1: "Bulky items",
      line2: "Request an appointment",
      logo: "logo_carouge_lg.png",
      mobileLogo: "logo_carouge.png",
      stickyLogo: "logo_carouge.png",
      favIcon: "favicon_carouge.ico"
    },
    subtitle: "on City of Carouge's online procedures platform",
    erreurStandard: "An error occured, please try again later",
    erreurSession: "Your session has expired, please restart your selection",
    precedent: "Previous step",
    suivant: "Next step",
    oui: "Yes",
    non: "No",
    contact: "Contact Service Voirie, espaces verts et matériel",
    step1: {
      title: "Address",
      comment:
        "Please enter your address to check the nearest deposit location.",
      recherchePlaceholder: "Enter an address",
      iconeMaisonTexte: "Your address",
      iconeDepotTexte: "Deposit address (if different from home address)",
      precisionLieuDepot: "Details about the place of deposit : ",
      precisionTravaux: "Work in progress : ",
      orthophotoTexte: "Show aerial view",
      erreur: {
        adresseObligatoire: "Entry of address is required."
      }
    },
    step2: {
      title: "Deposit date",
      info:
        "Select a date - Items must be deposited the day before the appointment, between 8.00 pm and 10.00 pm or the date of the appointment, before 7.00 am.",
      alerteInfo: "Your choice : ",
      legendeDisponible: "Available",
      legendeComplet: "Full",
      dateNonDisponible:
        "Your choice is no longer available, please select another date"
    },
    step3: {
      title: "Objects",
      info1: "A maximum of {nbMaxObject} items can be deposited.",
      info2: "For more information, see the page about ",
      info3: "\"Bulky items\"",
      punaisesTexte: "Are there actually bed bugs in your building  ?",
      punaisesModal: {
        texte: "If your bulky waste is contaminated with bed bugs, we invite you to contact us at {telephone}.<br/> We will provide you with free protective covers and stickers for your protection, that of the surrounding population, as well as that of our staff. <br/>Further instructions will be given to you when you visit our offices ({adresse})",
        oui: "My bulky waste is contaminated",
        non: "My waste is not contaminated (bed bugs only in my building)"
      },
      alerteMin: "You must select at least one object.",
      alerteMax: "The maximum number of objects is reached.",
      interdits: {
        dechspec: {
          libelle: "Special waste",
          legende:
              "Special waste"
        },
        matelect: {
          libelle: "Electric devices",
          legende:
              "Electric devices"
        },
        electromenager: {
          libelle: "Household appliances",
          legende:
              "Household appliances"
        },
        papier: {
          libelle: "Paper and cardboard",
          legende:
              "Paper and cardboard"
        },
        batteries: {
          libelle: "Batteries",
          legende:
              "Batteries"
        },
        eclaieco: {
          libelle: "Economical lighting",
          legende:
              "Economical lighting"
        },
        gravats: {
          libelle: "Rubble",
          legende:
              "Rubble"
        },
        pneus: {
          libelle: "Tires",
          legende:
              "Tires"
        },
        elecburo: {
          libelle: "Office electronic devices",
          legende:
              "Office electronic devices"
        },
      },
      objet: {
        petitMobilier: {
          libelle: "Small furniture",
          legende: "chair, dresser, low cabinet, stool, toilet cabinet, etc."
        },
        grosMobilier: {
          libelle: "Large furniture",
          legende: "wardrobe, desk, couch, sofa, table, etc."
        },
        literie: {
          libelle: "Bedding",
          legende: "bed frame, bedsprings, mattress (must be packed beforehand)"
        },
        moquetteTapis: {
          libelle: "Rugs",
          legende: "roll only"
        },
        appareilSport: {
          libelle: "Sports device",
          legende: ""
        },
        loisirVoyage: {
          libelle: "Leisure and travel",
          legende: "toy, suitcase, etc."
        },
        miroirVerre: {
          libelle: "Mirror and glass",
          legende: ""
        },
        fer: {
          libelle: "Iron",
          legende: "shelf, metal cabinet, etc."
        },
        bois: {
          libelle: "Wood",
          legende: "board, shelf, wooden crate"
        },
        articleCuisine: {
          libelle: "Kitchen accessory",
          legende: ""
        },
        accessoireDecoration: {
          libelle: "Accessory and decoration",
          legende: "planter, curtain rail, painting, etc."
        },
        divers: {
          libelle: "Various objects",
          legende: "stroller, child seat, parasol, ladder, drying rack, etc."
        },
        canape: {
          libelle: "Couch",
          legende: ""
        },
        sapin: {
          libelle: "Christmas tree",
          legende: ""
        }
      }
    },
    step4: {
      title: "Contact",
      nom: "Last Name",
      prenom: "First name",
      noTel: {
        libelle: "Phone number",
        placeholder: "Ex : 022 123 45 67 or 079 123 45 67"
      },
      email: "E-mail address",
      erreur: {
        nomObligatoire: "Entry of last name is required.",
        prenomObligatoire: "Entry of first name is required.",
        emailObligatoire: "Entry of an e-mail address  is required.",
        formatNonValide: "Invalid format.",
        longueur1: "Maximum 10 characters.",
        longueur2: "Maximum 30 characters.",
        longueur3: "Maximum 100 characters."
      },
      champsRequis: "Required fields *"
    },
    step5: {
      title: "Verification",
      info1: "Is your information correct ?",
      info2:
        "Remember to check your e-mail address, mandatory for the validation of your appointment.",
      adresse: "Address",
      lieuDepot: "Place of deposit",
      travaux: "Work in progress",
      dateChoisie: "Chosen date",
      lienModifier: "Edit",
      punaises1:
        "You have reported the presence of bed bugs in your building. It is mandatory to wrap any contaminated object with protective thick plastic bags and stickers that are available free of charge at {nom} - {adresse}. For more information, please call {telephone}.",
      certification1:
        "By checking this box, I certify that this request is made in a private capacity and does not concern a company, business, association, or any other professional activity, and attest having read the information on removal of bulky items available on the",
      certification2: "City of Carouge's website",
      erreur:
        "An error has occurred, we cannot validate your appointment, please try again later.",
      limite:
        "You can not make more than one reservation within a week.<br>" +
        "You have already validated at least one other reservation in the same period.<br>" +
        "Please choose another date.",
      dejaSupprime: "This appointment has already been deleted."
    },
    step6: {
      title: "Confirmation",
      info1:
        "Thank you for confirming your application using the e-mail that was sent to you.",
      info3:
          "You did not receive an e-mail? Check your junk mail (spam).",
      info4: "Any further information can be found on ",
      info5: "City of Carouge's website"
    },
    step7: {
      validationOk:
        "Thank you, your request of appointment for bulky items removal has been received.",
      info1:
          "An e-mail with the details of your appointment and a reservation number to mention in case of a control has been sent.",
      info2: "You did not receive an e-mail? Check your junk mail (spam).",
      rejetOk:
        "Thank you for your report, the request for bulky items removal has been cancelled.",
      erreur: "Your request could not be considered.",
      dejaValide: "The booking has already been validated.",
      dejaRejete: "The booking has already been rejected.",
      sessionExpiree: "Your session has expired.",
      messageErreur: "An error occured, please restart your request."
    },
    verification: {
      modification: "You have requested the modification of your appointment.",
      suppression: "You have requested the cancellation of your appointment.",
      info:
        "Before continuing, please enter the reservation number you received by e-mail :",
      numero: {
        libelle: "Reservation number",
        erreur: {
          obligatoire: "Entry of reservation number is required."
        }
      },
      erreur: {
        numero: "Invalid number.",
        modification: "This appointment can not be updated.",
        suppression: "This appointment can not be canceled."
      }
    },
    validation: {
      confirmation:
        "Please click on the Confirm button below to finalize your appointment request. \n" +
        "If you did not make this request, please let us know by clicking the Cancel button",
      button: {
        confirmation: "Confirm my appointment request",
        reject: "Cancel the request"
      },
      messageErreur:
        "Une erreur est survenue, merci de recommencer votre demande."
    },
    suppression: {
      info: "Are you sure you want to delete your appointment?",
      ok: "Your appointment has been deleted.",
      erreur: "An error has occured, please try again later."
    }
  }
};
